import { prepareData, service } from "./services";
import { getTheExactQuarter } from "./helpers";

export const onCreate = (player) => {
    player.on('ready', async () => {
        window.parent.postMessage(
            {
                info: 'sendDataToParent',
                value: { event: 'create', currentTime: player.cache_.currentTime }
            },
            '*'
        );
        let data = prepareData("create", player);
        await service(data);
    });
};

export const onPlay = (player) => {
    player.on('play', async () => {
        window.parent.postMessage(
            {
                info: 'sendDataToParent',
                value: { event: 'play', currentTime: player.cache_.currentTime }
            },
            '*'
        );
        let data = prepareData("play", player);
        await service(data);
    });
};

export const onSeek = (player) => {
    player.on('seeking', async () => {
        player.HasSeeked = true;
        player.seekCount += 1;
        window.parent.postMessage(
            {
                info: 'sendDataToParent',
                value: { event: 'seek', currentTime: player.cache_.currentTime }
            },
            '*'
        );
        let data = prepareData("seek", player);
        await service(data);
    });
};

export const onTimeUpdate = (player) => {
    player.on('timeupdate', async () => {
        if (Math.round(player.currentTime()) > player.currentT) {
            player.currentT = Math.round(player.currentTime());
            let data = prepareData("timeupdate", player);
            let event
            let Quarter = getTheExactQuarter(player.duration(), player.currentTime(), player.HasSeeked);
            switch (Quarter) {
                case 0:
                    event = "play"
                    break;
                case 1:
                    event = "first-quarter"
                    break;
                case 2:
                    event = "second-quarter"
                    break;
                case 3:
                    event = "third-quarter"
                    break;
                case 4:
                    event = "fourth-quarter"
                    break;
            }
            data['x-event'] = event;
            await service(data);
        }
    });
};

export const onPause = (player) => {
    player.on('pause', async () => {
        player.pauseCount += 1;
        window.parent.postMessage(
            {
                info: 'sendDataToParent',
                value: { event: 'pause', currentTime: player.cache_.currentTime }
            },
            '*'
        );
        player.bigPlayButton.show();
        let data = prepareData("pause", player);
        await service(data);
    });
};

export const onLoad = (player) => {
    player.on('load', async () => {
        window.parent.postMessage(
            {
                info: 'sendDataToParent',
                value: { event: 'loaded', currentTime: player.cache_.currentTime }
            },
            '*'
        );
        let data = prepareData("load", player);
        await service(data);
    });
};

export const Ended = (player) => {
    player?.on('ended', async () => {
        window.parent.postMessage(
            {
                info: 'sendDataToParent',
                value: { event: 'ended', currentTime: player.cache_.currentTime }
            },
            '*'
        );
        let data = prepareData("performance", player);
        await service(data);
    });
};
